import { isIOS } from '../../../../../../Foundation/Common/code/Utils/Utils.js';

export const setupFilterDropdown = () => {
  let dropdown = document.querySelector('.thule-filter-select') as HTMLDivElement;

  if (!dropdown) return;

  let select = dropdown.querySelector('select') as HTMLSelectElement;
  let icon = dropdown.querySelector('.trailing-icon') as HTMLElement;
  let optionsDiv = dropdown.querySelector('.options') as HTMLDivElement;
  let options = dropdown.querySelectorAll('.option') as NodeListOf<HTMLDivElement>;
  let body = document.querySelector('body');

  body.addEventListener('mousedown', (e) => {
    if ((e.target as HTMLElement).closest('.thule-select')?.id !== 'thule-product-variant-dropdown') {
      closeSelect(select, optionsDiv, icon);
      select.blur();
    }
  });

  select.addEventListener('mousedown', (e) => {
    onSelectMouseDown(e, select, optionsDiv, icon);
  });

  select.addEventListener('keydown', (e) => {
    onSelectKeyDown(e, select, options, optionsDiv, icon);
  });

  select.addEventListener('change', (e) => {
    onSelectChange(e, options);
  });

  options.length &&
    options.forEach((option, index) => {
      option.addEventListener('mousedown', (e) => {
        onOptionMouseDown(index, select, options);
      });
    });
};

const onSelectMouseDown = (e: MouseEvent, select: HTMLSelectElement, optionsDiv: HTMLDivElement, icon: HTMLElement) => {
  e.preventDefault();
  (e.target as HTMLSelectElement).focus();
  if (isIOS()) (e.target as HTMLSelectElement).blur();

  select.ariaExpanded = select.ariaExpanded === 'true' ? 'false' : 'true';

  if (optionsDiv.classList.contains('d-none')) {
    icon.classList.remove('rot-270');
    icon.classList.add('rot-90');
  } else {
    icon.classList.remove('rot-90');
    icon.classList.add('rot-270');
  }

  optionsDiv.classList.toggle('d-none');
};

const onSelectKeyDown = (
  e: KeyboardEvent,
  select: HTMLSelectElement,
  options: NodeListOf<HTMLDivElement>,
  optionsDiv: HTMLDivElement,
  icon: HTMLElement
) => {
  if (e.key === 'Escape') {
    e.preventDefault();
    closeSelect(select, optionsDiv, icon);
  } else if (e.key === 'Enter') {
    e.preventDefault();
    if (select.ariaExpanded === 'true') {
      updateSelectedOption((e.target as HTMLSelectElement).selectedIndex, options);

      if (window.location.pathname !== select.selectedOptions[0].value) {
        window.location.href = select.selectedOptions[0].value;
      } else {
        closeSelect(select, optionsDiv, icon);
      }
    } else {
      optionsDiv.classList.remove('d-none');
      select.ariaExpanded = 'true';
    }
  } else if (e.key === ' ') {
    e.preventDefault();
    optionsDiv.classList.remove('d-none');
    select.ariaExpanded = 'true';
  } else if (e.key === 'ArrowUp') {
    e.preventDefault();

    if (select.selectedIndex > 0) {
      select.selectedIndex = select.selectedIndex - 1;
      updateSelectedOption(select.selectedIndex, options);
    }
  } else if (e.key === 'ArrowDown') {
    e.preventDefault();

    if (select.selectedIndex < options.length - 1) {
      select.selectedIndex = select.selectedIndex + 1;
      updateSelectedOption(select.selectedIndex, options);
    }
  }
};

const onSelectChange = (e: Event, options: NodeListOf<HTMLDivElement>) => {
  updateSelectedOption((e.target as HTMLSelectElement).selectedIndex, options);
};

const onOptionMouseDown = (index: number, select: HTMLSelectElement, options: NodeListOf<HTMLDivElement>) => {
  updateSelectedOption(index, options);

  if (window.location.pathname !== select.options[index].value) window.location.href = select.options[index].value;
};

const updateSelectedOption = (index: number, options: NodeListOf<HTMLDivElement>) => {
  options.forEach((option) => {
    option.ariaSelected = 'false';
    option.classList.remove('selected');
  });

  let selectedOption = options[index];
  selectedOption.ariaSelected = 'true';
  selectedOption.classList.add('selected');

  selectedOption.scrollIntoView({ block: 'nearest' });
};

const closeSelect = (select: HTMLSelectElement, optionsDiv: HTMLDivElement, icon: HTMLElement) => {
  optionsDiv.classList.add('d-none');
  icon.classList.remove('rot-90');
  icon.classList.add('rot-270');
  select.ariaExpanded = 'false';
};
